/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useMediaQuery, useTheme } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';
import { getSafeHTML } from 'utils';
import * as S from './styles';

const PhotoContestDescription = ({
  title,
  teaser,
}: {
  title: string;
  teaser?: string;
}): JSX.Element => {
  const theme: ICustomTheme = useTheme();
  const isDownSm = useMediaQuery(theme.breakpoints.down('sm'));
  const safeTeaser = getSafeHTML(teaser || '');

  return (
    <S.Card>
      <S.Title variant={isDownSm ? 'h5' : 'h3'}>{title}</S.Title>
      {teaser && (
        <S.StyledTeaser>
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: safeTeaser,
            }}
          />
        </S.StyledTeaser>
      )}
    </S.Card>
  );
};

export default PhotoContestDescription;
